<div class="mb-3">
  <app-field-title [titleInfo]="detailInfo" [formControlObj]="formControlObj">
    <div class="input-group clockpicker">
      <input bsDatepicker class="form-control" autoClose="false"
        [placeholder]="isOptionLoading ? 'Loading..' : datePlaceholder" [formControl]="formControlObj"
        [bsConfig]="bsConfig" (bsValueChange)="onDateChange($event)">
    </div>
  </app-field-title>
</div>